import documentInit from './modules/document';
import mobileNavInit from './modules/mobile-nav';
import navInit from './modules/nav';
import accordionInit from './modules/accordion';
import slickInit from './modules/slick';
import tabsInit from './modules/tabs';
import fancyboxInit from './modules/fancybox';
import faqInit from './modules/faq';
import contactFormInit from './modules/contact-form';
import configuratorInit from './modules/configurator';
import advisorInit from './modules/advisor';
import scrollerInit from './modules/scroller';
import topInfoBarInit from './modules/top-info-bar';
import fixtoInit from './modules/fixto';
import scrollNavInit from './modules/scroll-nav';
import footerInit from './modules/footer';

(function ($) {

	$(document).ready(function () {

		documentInit();
		navInit();
		mobileNavInit();
		footerInit();
		accordionInit();
		tabsInit();
		scrollerInit();
		scrollNavInit();

		fancyboxInit();
		slickInit();
		fixtoInit();

		faqInit();
		topInfoBarInit();
		contactFormInit();
		configuratorInit();
		advisorInit();

		$(document).trigger('hp-plugins-loaded');

	});

})(jQuery);